<template>
  <header
    class="flex items-center h-full mainheader bg-base-0"
    :class="{'searching': searchValue}"
  >
    <span
      v-if="!isDisabled"
      class="px-4 py-4 cursor-pointer lg:hidden"
      @click="showMenuMobile"
    >
      <aha-icon
        name="hamburger-menu"
        class="text-secondary-100"
      />
    </span>

    <!-- Hack: Use div instead of ahref to avoid focus-within state which triggers search UX -->
    <div
      v-if="!isPresenterWhiteLabel"
      class="logo-merge-search-wrapper"
      @click="onClickLogo"
    >
      <aha-logo
        width="156"
        height="26"
        viewBox="0 0 9600 1602"
        class="block m-auto lg:ml-3.5"
      />
    </div>
    <div
      v-if="currentUser.id && !isHideSearchTemplateEu"
      class="merge-template-search-wrapper"
      :class="{'show': isTemplateSearchVisible}"
    >
      <TemplateSearch></TemplateSearch>
    </div>
    <span class="flex-grow hidden lg:inline-block" />

    <span
      v-if="currentUser.plan !== 'white-label' && !isEURegion"
      class="mr-4 cursor-pointer gradient-gift text-secondary-100 relative noti-icon"
      @click.stop="toggleShowHideNotificationPanel"
    >
      <div class="relative">
        <img src="@/assets/images/bell.svg" />
        <span v-if="$store.state.notificationUnread" class="notification-status"></span>
        <span class="noti-shadow"></span>
        <!-- Enable khi cần xử dụng lại tính năng push notification -->
        <!-- <PushNotification v-if="currentUser.id && presentations.length" /> -->
      </div>
    </span>

    <a
      v-if="currentUser.referralUserId && !currentUser.referralAwardStatus"
      class="flex mr-4 cursor-pointer gradient-gift text-secondary-100"
      @click="openReferral"
    >
      <img src="@/assets/images/icon/box.svg" class="relative -top-0.5 mr-1">
      <span class="text-gift">{{ $i18nPresenter.t("You’ve got a gift") }}</span>
    </a>

    <span
      v-if="$store.state.plan.group == 'free' && $route.name !== 'Upgrade'"
      v-show="!hasOnboardingV3"
      class="hidden mb-1 mr-4 lg:inline-block"
      @click="onClickBtnUpgrade(true)"
    >
      <aha-button variant="success" class="py-1.5">
        {{ $i18nPresenter.t("Upgrade") }}
      </aha-button>
    </span>

    <span
      @click="onClickBtnUpgrade"
    >
      <aha-plan-badge
        v-if="$store.state.plan.group != 'free'"
        :plan="$store.state.plan.name"
        class="hidden mr-4 plan-badge lg:inline-block badge-main-header"
        :class="{'lg:hidden': isPageUserCancelSub}"
      />
    </span>

    <aha-dropdown
      v-if="$store.state.plan.name"
      class="hidden lg:inline-block"
      :class="{'lg:hidden': isPageUserCancelSub}"
    >
      <aha-dropdown-trigger>
        <div
          class="flex items-center cursor-pointer dropdown-wrapper"
          @click="isProfileShowing = true"
        >
          <p
            class="inline-block mr-4 font-bold truncate dropdown-username
              text-link max-w-64 xl:max-w-108"
          >
            {{ $store.state.currentUser.firstName }} {{ $store.state.currentUser.lastName }}
          </p>
          <aha-avatar
            :id="$store.state.currentUser.id"
            :name="`${$store.state.currentUser.firstName} ${$store.state.currentUser.lastName}`"
            :image="$store.state.currentUser.avatar"
            :width="40"
            :height="40"
            class="mr-2 text-lg"
          />
          <aha-icon class="mr-6" name="polygon" />
        </div>
      </aha-dropdown-trigger>
      <transition name="fade" appear>
        <div
          v-if="isProfileShowing"
          v-click-outside="handleClickOutsideProfile"
          class="absolute z-10 p-4 mt-6 rounded-md right-4 bg-base-0 shadow-dialog w-72"
        >
          <div
            class="flex p-2 rounded-md"
            :class="$store.state.plan.color2"
          >
            <aha-avatar
              :id="$store.state.currentUser.id"
              :name="`${$store.state.currentUser.firstName} ${$store.state.currentUser.lastName}`"
              :image="$store.state.currentUser.avatar"
              :width="48"
              :height="48"
              class="text-xl"
            />
            <div class="flex flex-col justify-between py-1 pl-3">
              <p class="font-bold truncate max-w-40">
                {{ $store.state.currentUser.firstName }} {{ $store.state.currentUser.lastName }}
              </p>
              <p class="text-xs truncate max-w-40">
                {{ $store.state.currentUser.email }}
              </p>
            </div>
          </div>
          <ul class="aha-menu">
            <li
              v-if="currentUser.identifyProvider != 'skoletube'"
              @click="routeAndClose('/apps/user-profile')"
            >
              <aha-icon name="profile" maintain-color />
              <span>{{ $i18nPresenter.t("My Profile") }}</span>
            </li>
            <li
              v-if="currentUser.identifyProvider != 'skoletube' && !hasOnboardingV3
                && !isIdealEUplan"
              @click="routeAndClose('/apps/referral')"
            >
              <aha-icon name="coin" class="top opacity-60" />
              <span v-if="currentUser.isRefererEduPromotionGroup">
                {{ $i18nPresenter.t("Refer a Teacher") }}
              </span>
              <span v-else>
                {{ $i18nPresenter.t("Refer a Friend") }}
              </span>
            </li>
            <li
              v-if="currentUser.identifyProvider != 'skoletube'
                && (workingMode !== 'team')"
              @click="routeAndClose('/apps/user-plan')"
            >
              <aha-icon name="bill" maintain-color />
              <span>{{ $i18nPresenter.t("My Plan") }}</span>
              <aha-plan-badge
                :plan="$store.state.plan.name"
                use-short-name
                size="sm"
                class="float-right mt-2"
              />
            </li>
            <li
              v-if="currentUser.identifyProvider != 'skoletube'"
              @click="routeAndClose('/apps/billing')"
            >
              <aha-icon name="payment" maintain-color />
              <span>{{ $i18nPresenter.t("Payment") }}</span>
            </li>
            <li @click="handleLogoutButtonClick">
              <aha-icon name="logout" maintain-color />
              <span>{{ $i18nPresenter.t("Log out") }}</span>
            </li>
          </ul>
        </div>
      </transition>
    </aha-dropdown>
    <ReferralGift
      v-if="isOpenReferral && !isRefereeEduPromotionGroup"
      @hide="closeReferral()"
    />
    <ReferralGiftTeacher
      v-if="isOpenReferral && isRefereeEduPromotionGroup"
      @hide="closeReferralTeacher()"
    />
  </header>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import debounce from 'debounce'
import config from '@/config'
import constants from '@/constant'
import utils from '@/util'
import UserApi from '@/api/user'

import ReferralGift from '@/components-v2/modals/ReferralGift.vue'
import TemplateSearch from '@/components-v2/template/TemplateSearch.vue'
import ReferralGiftTeacher from '@/components-v2/modals/ReferralGiftTeacher.vue'

const iconOpenLink = require('@/assets/images/vector.svg')

const { eventCategories } = constants

export default {
  components: {
    ReferralGift,
    TemplateSearch,
    ReferralGiftTeacher,
  },
  props: {
    isTemplateSearchVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isProfileShowing: false,
      searchValue: '',
      tooltipHelp: {
        content: '',
      },
      isOpenReferral: false,
      isLoadingOpenNotification: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      plan: (state) => state.plan,
      isPresenterWhiteLabel: (state) => state.isPresenterWhiteLabel,
      hasOnboardingV3: (state) => state.indicators.hasOnboardingV3,
      isOnboardingV3Showing: (state) => state.indicators.isOnboardingV3Showing,
      workingMode: (state) => state.workingMode,
      presentations: (state) => state.presentations,
    }),
    isCasualUserNotHaveTeam() {
      return this.currentUser && !this.currentUser.accountId
    },
    isDisabled() {
      return this.$route.name === 'Upgrade' || this.$route.name === 'UserCancelSub'
    },
    isPageUserCancelSub() {
      return this.$route.name === 'UserCancelSub'
    },
    isEURegion() {
      return config.region === constants.euRegion
    },
    isIdealEUplan() {
      return this.currentUser.currency === 'eur'
    },
    isHideSearchTemplateEu() {
      if (this.isEURegion && this.$route.name === 'TemplateLibrary') {
        return true
      }

      return false
    },
    isRefereeEduPromotionGroup() {
      return this.currentUser && this.currentUser.isRefereeEduPromotionGroup
    },
  },
  watch: {
    $route(to) {
      if (to.name === 'Presentations') {
        this.searchValue = this.$route.query.q || ''
      } else {
        this.searchValue = ''
      }
    },
    currentUser: {
      handler(value) {
        if (
          !this.isOpenReferral
          && this.isRefereeEduPromotionGroup
          && !this._hasShowPromotionTeacherPopup(value)
        ) {
          this.isOpenReferral = true
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.tooltipHelp.content = this.$i18nPresenter.t('ThisLinkOpensInANewTab', { iconOpenLink })
    if (this.$route.query.q) {
      this.searchValue = this.$route.query.q
    }
  },
  methods: {
    ...mapActions(['setIsOnboardingV3ShowingAction']),
    onClickBtnUpgrade(isUpdate = false) {
      if (config.region !== constants.euRegion) {
        let eventLabel = 'Free'
        if (isUpdate) {
          eventLabel = this.$store.state.plan.name
        }
        utils.mixpanelTracking(this.$route.meta.title, 'Presenter App > Header > Upgrade', eventLabel)
        this.$router.push({ name: 'UserPlan' })
      }
    },
    openReferral() {
      this.isOpenReferral = true
      utils.mixpanelTracking(
        'Presenter Referral Program',
        'Presenter Referral Program > Click open gift ',
        'Click open gift',
      )
    },
    closeReferral() {
      this.isOpenReferral = false
    },
    async closeReferralTeacher() {
      this.isOpenReferral = false

      if (this.isRefereeEduPromotionGroup
        && !this._hasShowPromotionTeacherPopup(this.currentUser)
      ) {
        await this.$http.put(config.api.updateUserSettings, {
          hasShowPromotionTeacherPopup: true,
        })
      }
    },
    _hasShowPromotionTeacherPopup(user) {
      return user
        && user.rememberSettings
        && user.rememberSettings.hasShowPromotionTeacherPopup
    },
    handleLogoutButtonClick() {
      utils.logout(this.currentUser)
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Logout')
    },

    _onSearchInput: debounce(function onSearchInputDebounce() {
      const query = {}
      if (this.searchValue.length !== 1) {
        if (this.searchValue.length > 1) {
          query.q = this.searchValue
        }
        this.$router.push({ name: 'Presentations', query })
      }
    }, 600),

    routeAndClose(path) {
      this.setIsOnboardingV3ShowingAction(false)
      this.$router.push(path)
      this.isProfileShowing = false
      if (window.innerWidth > 1023 && localStorage.getItem(`skipped-welcome-popup-${this.currentUser.id}`) === 'true') {
        this.$emit('showHomeSideBar')
      }
    },

    handleClickOutsideProfile() {
      this.isProfileShowing = false
    },

    showMenuMobile() {
      this.$store.state.indicators.isHomeSideBarShowing = true
    },
    hideMenuMobile() {
      if (window.innerWidth > 1023) return
      this.$store.state.indicators.isHomeSideBarShowing = false
    },
    focusSearch() {
      this.$refs.search.focus()
    },
    onClickLogo() {
      if (this.$route.name === 'Upgrade') {
        // Dont use vue-router on Upgrade page, to clean up state and reload full page.
        this.$func.go(`${config.presenterDomain}/apps/presentations`)
      } else {
        if (this.$store.state.workingMode === 'personal') this.$router.push({ name: 'Presentations' })
        else this.$router.push({ name: 'Team' })
        if (this.hasOnboardingV3) {
          this.setIsOnboardingV3ShowingAction(true)
        }
      }
    },
    async toggleShowHideNotificationPanel() {
      this.$store.state.isShowNotificationPanel = !this.$store.state.isShowNotificationPanel
      if (this.$store.state.isShowNotificationPanel) {
        this.$store.state.notificationUnread = 0
        await UserApi.patchUserById(this.currentUser.id, {
          notificationReadTime: new Date(),
        })
      }
      this._trackEvent('Header > Noti > Open', {})
    },
    _trackEvent(action, data, event_label = null) {
      utils.mixpanelTracking(
        this.$route.name,
        action,
        event_label,
        null,
        data,
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.search-presentation-wrapper {
  @apply lg:ml-6 flex items-center;
  transition: .15s ease;
}

.search-presentation-wrapper.disabled {
  @apply hidden;
}

.logowrapper {
  @apply opacity-100 flex-grow lg:flex-grow-0 lg:w-auto cursor-pointer;
  transition: .15s ease;
}

.search-presentation-wrapper:hover {
  .search__icon {
    @apply text-primary-90;
  }
}

.mainheader.searching,
.mainheader:focus-within {
  .logowrapper {
    @apply opacity-0 overflow-hidden max-w-0 lg:max-w-full lg:opacity-100 lg:w-auto;
  }
}

.search-presentation-wrapper.has-value,
.search-presentation-wrapper:focus-within {
  @apply w-full max-w-full lg:w-auto;

  .search__icon {
    @apply text-primary-90;
  }

  form {
    @apply w-4/5 lg:w-auto;
  }

  .search__input,
  .search__input:focus {
    @apply opacity-100 mr-4 w-full max-w-full lg:w-56;
  }
}

.search__input {
  @apply outline-none inline-block flex-grow w-0 max-w-56 lg:w-56 mr-2;
  @apply cursor-pointer;
  -webkit-appearance: none;
}

.search__icon {
  @apply text-base-80 lg:text-base-50;
  transition: .15s ease;
}

.aha-menu {
  @apply mt-2;

  li {
    @apply leading-10 px-3 hover:bg-base-20 cursor-pointer;
    @apply text-base-90 whitespace-nowrap;
    svg {
      @apply mr-2;
    }
  }
}
.aha-menu-title {
  @apply uppercase tracking-widest text-xs px-3 my-2;
}

.dropdown-wrapper {
  &:hover .dropdown-username {
    @apply text-primary-90;
  }
}
p.dropdown-username {
  @apply capitalize;
  line-height: 1.1rem;
  .credit {
    @apply font-light text-base-80 text-xs;
    margin-top: 2px;
    display: block;

    img {
      position: relative;
      top: -2px;
    }
  }
}

.icon-color {
  opacity: 0.6;
}

.merge-template-search-wrapper {
  @apply w-1/2 hidden;
  &.show {
    @apply block;
  }
}
@media (max-width: 1024px) {
  .text-gift {
    display: none;
  }
  .merge-template-search-wrapper {
    width: 100%;
    padding-right: 42px;
  }
}

.logo-merge-search-wrapper {
  @apply cursor-pointer;
}

.plan-badge{
  &:hover{
    cursor: pointer;
  }
}

.badge-main-header{
  &:hover{
    &.bg-yellow-50{
      box-shadow: 0 1px 10px rgb(255 174 9 / 40%);
    }
    &.bg-green-50{
      box-shadow: 0 1px 10px rgb(40 194 112 / 40%);
    }
    &.bg-purple-50{
      box-shadow: 0 1px 10px rgb(118 105 191 / 40%);
    }
    &.bg-primary-90{
      box-shadow: 0 1px 10px rgb(52 142 246 / 40%);
    }
  }
}

.notification-status {
  width: 6px;
  height: 6px;
  display: block;
  position: absolute;
  top: 0;
  right: -6px;
  border-radius: 6px;
  background-color: #FF4954;
}

.noti-shadow {
  position: absolute;
  display: block;
  width: 40px;
  height: 40px;
  top: -12px;
  left: -13px;
  background-color: #EEF1F6;
  border-radius: 50px;
  z-index: 5;
  opacity: 0;
  transition: all 0.15s ease-in-out;
}

.noti-icon {
  margin-right: 28px;
  img {
    position: relative;
  }
  img, .notification-status {
    z-index: 10;
  }
  &:hover {
    .noti-shadow {
      opacity: 1;
    }
  }
}

@media (max-width: 1024px) {
  .noti-icon {
    position: absolute;
    right: 0;
    margin-right: 16px;
    img {
      width: 18px;
    }
  }

  .noti-shadow {
    top: -9px;
    left: -11px;
  }
}

</style>
